import { render, staticRenderFns } from "./scopeOfWork.vue?vue&type=template&id=4142cdf1"
import script from "./scopeOfWork.vue?vue&type=script&lang=ts"
export * from "./scopeOfWork.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports